module.exports = __webpack_public_path__ + "static/media/Camps.f822814d.jpg";